import * as _ from "lodash";
import { useState } from "react";
import { useRouter } from "next/router";
import World from "../world";
import { MaybeAPIErr } from "../api";

type InviteHook = {
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
    error: MaybeAPIErr;
    isPending: boolean;
}

function useInvite(world: World, galleryName: string, galleryID: number): InviteHook {
    const [fullName, setFullName] = useState("");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState<MaybeAPIErr>(null);
    const [isPending, setIsPending] = useState(false);

    const router = useRouter();

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        switch (e.currentTarget.name) {
        case "full_name":
            setFullName(e.currentTarget.value);
            break;
        case "phone":
            setPhone(e.currentTarget.value);
            break;
        }
    }

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setIsPending(true);
        setError(null);

        const [guest, err] = await world.createGuest(galleryName, {
            full_name: fullName,
            phone: phone,
        });

        setIsPending(false);

        if (err) {
            setError(err);
            return;
        }

        router.push("/dashboard/[[...all]]", `/dashboard/galleries/${galleryID}`);
    }

    return {
        onChange,
        onSubmit,
        error,
        isPending,
    };
}

export default useInvite;
